/* eslint-disable no-console */

import localForage from 'localforage';

const algorithm = 'SHA-512';
export default class OfflineLogin {
  databases: Record<string, LocalForage> = {};

  private async getDBForClientCode(clientCode) {
    this.databases[clientCode] =
      this.databases[clientCode] ??
      localForage.createInstance({
        name: `offlineLogin`,
        storeName: clientCode,
      });
    return this.databases[clientCode];
  }

  private static async toHexHash(text: string) {
    const inpArr = new TextEncoder().encode(text);
    const outArr = await window.crypto.subtle?.digest(algorithm, inpArr);
    return Array.from(new Uint8Array(outArr))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }

  async setUser(clientCode, user, password) {
    const hash = await OfflineLogin.toHexHash(password);
    return this.getDBForClientCode(clientCode).then(db =>
      db.setItem(user.userName, { ...user, passwordHash: hash }),
    );
  }

  async getUser(clientCode, userName, password): Promise<any | null> {
    const hash = await OfflineLogin.toHexHash(password);
    return this.getDBForClientCode(clientCode)
      .then(db => db.getItem(userName))
      .then((user: any) => (user.passwordHash === hash ? user : null));
  }
}
